export const partners = [
  {
    id: "__partner_01__",
    name: "Talentstories",
    image: "/images/partners/talentstories.webp",
  },
  {
    id: "__partner_02__",
    name: "Identifi",
    image: "/images/partners/Identifi.webp",
  },
  {
    id: "__partner_03__",
    name: "Design Hive",
    image: "/images/partners/designHive.webp",
  },
  {
    id: "__partner_03__",
    name: "HOV",
    image: "/images/partners/hov.webp",
  },
];
